import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addExperiment } from '@/vdp/VehicleDetailsContainer/actions';

export default function useAddExperimentToStore(
  experimentName: string,
  assignedBucket: string
): boolean {
  const dispatch = useDispatch();
  const [didLoad, setDidLoad] = useState(false);

  useEffect(() => {
    if (assignedBucket == null) return;
    dispatch(addExperiment({ experimentName, assignedBucket }));
    setDidLoad(true);
  }, [assignedBucket, dispatch, experimentName]);

  return didLoad;
}
